import { useCallback } from 'react'
import type { DocumentationState } from '@/types/documentation'

const DRAFT_KEY_PREFIX = 'determa-doc-draft-'
const DRAFT_VERSION = 1

export function useDocumentationDraft(visitId: string) {
  const key = `${DRAFT_KEY_PREFIX}${visitId}`

  const saveDraft = useCallback(
    (state: DocumentationState) => {
      try {
        localStorage.setItem(
          key,
          JSON.stringify({ _v: DRAFT_VERSION, ...state }),
        )
      } catch {
        // localStorage may be full or unavailable
      }
    },
    [key],
  )

  const loadDraft = useCallback((): DocumentationState | null => {
    try {
      const raw = localStorage.getItem(key)
      if (!raw) return null
      const parsed = JSON.parse(raw)
      // Discard drafts from incompatible versions
      if (parsed._v !== DRAFT_VERSION) return null
      const { _v: _, ...state } = parsed
      return state as DocumentationState
    } catch {
      return null
    }
  }, [key])

  const clearDraft = useCallback(() => {
    try {
      localStorage.removeItem(key)
    } catch {
      // ignore
    }
  }, [key])

  return { saveDraft, loadDraft, clearDraft }
}
